function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../Box';
import Flex from '../Flex';
import Input from './Input';
import Prefix from './Prefix';
const PrefixedInput = /*#__PURE__*/React.memo(_ref => {
  let {
    prefix,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Prefix, null, prefix)), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Input, _extends({
    hasPrefix: true
  }, props))));
});
PrefixedInput.propTypes = {
  prefix: PropTypes.any.isRequired,
  ...Input.propTypes
};
PrefixedInput.defaultProps = {};
PrefixedInput.displayName = 'PrefixedInput';
export default PrefixedInput;